import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ZoneSearchComponent } from "./zone/zone-search/zone-search.component";
import { ZoneCreateOrUpdateComponent } from "./zone/zone-create-or-update/zone-create-or-update.component";
import { EnvironmentSearchComponent } from "./environment/environment-search/environment-search.component";
import { EnvironmentCreateOrUpdateComponent } from "./environment/environment-create-or-update/environment-create-or-update.component";
import { PlatformSearchComponent } from "./platform/platform-search/platform-search.component";
import { PlatformCreateOrUpdateComponent } from "./platform/platform-create-or-update/platform-create-or-update.component";

const routes: Routes = [
 // Redirect the workflow root to the Zone search page.
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'zone/search',
  },

  // ============================================================
  // Zone Management
  // ============================================================

  {
    path: 'zone/search',
    component: ZoneSearchComponent,
  },
  {
    path: 'zone/create',
    component: ZoneCreateOrUpdateComponent,
    data: { create: true },
  },
  {
    path: 'zone/update/:zoneId',
    component: ZoneCreateOrUpdateComponent,
    data: { create: false },
  },

  // ============================================================
  // Environment Management
  // ============================================================

  {
    path: 'environment/search',
    component: EnvironmentSearchComponent,
  },
  {
    path: 'environment/create',
    component: EnvironmentCreateOrUpdateComponent,
    data: { create: true },
  },
  {
    path: 'environment/update/:environmentId',
    component: EnvironmentCreateOrUpdateComponent,
    data: { create: false },
  },

  // ============================================================
  // Platform Management
  // ============================================================

  {
    path: 'platform/search',
    component: PlatformSearchComponent,
  },
  {
    path: 'platform/create',
    component: PlatformCreateOrUpdateComponent,
    data: { create: true },
  },
  {
    path: 'platform/update/:platformId',
    component: PlatformCreateOrUpdateComponent,
    data: { create: false },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ZoneManagementRouter {}